import {
    ReactElement,
} from 'react';

import {Stack,} from '@mantine/core';

import {useDeploymentAccountGroups} from '../hooks/useDeploymentAccountGroups.ts';

import {
    MantineDataTable,
    SimpleTableBatchAction,
} from '@flexinet/ui-components';
import {useDeploymentAccountGroupsSelection} from '../hooks/useDeploymentAccountGroupsSelection.ts';
import {useDeploymentAccountGroupsPaging} from "../hooks/useDeploymentAccountGroupsPaging.ts";
import {useDeploymentAccountGroupsSearch} from "../hooks/useDeploymentAccountGroupsSearch.ts";
import {useDeploymentAccountGroupsTableColumns} from "../hooks/useDeploymentAccountGroupsTableColumns.tsx";
import {DataTableColumn} from "mantine-datatable";

export const RecordsTable = ({
                                 extraTools,
                                 settings,
                             }: {
    extraTools?: ReactElement[],
    settings?: { label: string, onClick: () => void }[]
}) => {

    const {
        visibleItems: records,
        loading,
    } = useDeploymentAccountGroups();

    const {
        columns,
    } = useDeploymentAccountGroupsTableColumns();

    const {
        page,
        limit,
        totalCount,
        handleItemsPerPageChange,
        handlePageChange,
    } = useDeploymentAccountGroupsPaging(records.length);

    const {
        handleFilterByKeyword,
    } = useDeploymentAccountGroupsSearch();

    const {
        handleClearSelection
    } = useDeploymentAccountGroupsSelection();

    return (
        <Stack>
            <SimpleTableBatchAction
                limit={limit}
                handleItemsPerPageChange={(pageSize) => handleItemsPerPageChange(Number(pageSize))}
                settings={settings}
                handleFilterByKeyword={handleFilterByKeyword}
                extraTools={extraTools}
            />


            <MantineDataTable
                columns={columns as DataTableColumn[]}
                records={records}
                totalRecords={totalCount}
                recordsPerPage={limit}
                page={page}
                onPageChange={handlePageChange}
                paginationText={({
                                     from,
                                     to,
                                     totalRecords
                                 }) => `Records ${from} - ${to} of ${totalRecords}`}
                paginationSize={'md'}
                selectedRecords={[]}
                onSelectedRecordsChange={() => {
                    handleClearSelection();
                }}
                fetching={loading}
            />


        </Stack>
    );


};
